import React, { useEffect, useRef, useState } from "react";
import ButtonZegel from "../Buttons/ButtonZegel";
import DialogZegel from "../Dialog/DialogZegel";
import "./styles/CardCurso.scss";

import moment from "moment";
import { ProgressBar } from "primereact/progressbar";
import { classNames } from "primereact/utils";
import { useNavigate } from "react-router-dom";
import { handleDownloadCertificado, timeToSeconds } from "../../helpers/helpers";
import useAlumno from "../../hooks/useAlumno";
import { PrivateRoutes } from "../../routes/routes";
import { CertificadoFCursoAdmi } from "../../services/CertificadosServices";
import { ObtenerEvaluacionesPersonaCurso } from "../../services/EvaluacionService";
import { ObtenerProgresoCursoPorPersonaCurso } from "../../services/ProgresoService";
import { ListarUnidadesPorCurso } from "../../services/UnidadService";
import {
  ActualizarCursoEstado,
  SolicitarAmpliacion,
  ObtenerCertificadoPersonaCurso,
} from "../../services/UsuarioService";

function CardPrograma({ curso, personaPrograma = null, idPrograma = null }) {
  const navigate = useNavigate();
  let { perfil } = useAlumno();
  let { configuraciones } = useAlumno();
  const [showAlert, setShowAlert] = useState(null);
  const [contenidoAlertActivar, setContenidoAlertActivar] = useState(null);
  const [progresoCurso, setProgresoCurso] = useState(null);
  const toast = useRef(null);

  const [listaLecciones, setListaLecciones] = useState([]);
  //const [listaUnidades, setListaUnidades] = useState([{ idUnidad: 0 }]);
  const [listaUnidades, setListaUnidades] = useState(null);
  const [ProgresoUnidad, setProgresoUnidad] = useState([
    {
      idUnidad: 0,
      promedioPorcentaje: 0,
    },
  ]);
  const [evaluacionesProgreso, setEvaluacionesProgreso] = useState(0);
  const [cursoExpirado, setcursoExpirado] = useState(false);
  const [cursoExpiradoAmpliacion, setCursoExpiradoAmpliacion] = useState(false);
  const [cursoExpiradoMembresia, setCursoExpiradoMembresia] = useState(false);

  const [showAmpliacion, setShowAmpliacion] = useState(false);
  const [loading, setLoading] = useState(false);

  const [ShowEstaPorvencer, setShowEstaPorvencer] = useState(false);
  const [AlertaEstaPorvencer, setAlertaEstaPorvencer] = useState(false);

  const [Evaluaciones, setEvaluaciones] = useState(null);

  const getProgresoCurso = () => {
    let jwt = window.localStorage.getItem("jwt");
    let idPersonaCurso = curso.idPersonaCurso;
    ObtenerProgresoCursoPorPersonaCurso({ jwt, idPersonaCurso }).then(
      (data) => {
        setProgresoCurso(data);
      }
    );
  };
  useEffect(() => {
    if (curso) {
      if (new Date(curso.fechaVigencia) < new Date()) {
        if (curso.fechaAmpliacionCurso) {
          if (new Date(curso.fechaAmpliacionCurso) < new Date()) {
            setCursoExpiradoAmpliacion(true);
          }
        }
        setcursoExpirado(true);
      }

      if (curso.fechaVigenciaMembresia) {
        if (new Date(curso.fechaVigenciaMembresia) < new Date()) {
          setCursoExpiradoMembresia(true);
          setcursoExpirado(true);
        }
      }
    }
  }, [curso]);

  useEffect(() => {
    if (curso && curso.idEstado == 2) getProgresoCurso();
  }, [curso]);
  useEffect(() => {
    const getUnidades = () => {
      let jwt = window.localStorage.getItem("jwt");
      let idCurso = curso.idCurso;
      ListarUnidadesPorCurso({ jwt, idCurso }).then((data) => {
        setListaUnidades(data);
      });
    };
    if (curso) getUnidades();
  }, [curso]);

  useEffect(() => {
    let porcentajeEva = 0;
    if (curso && listaUnidades) {
      let jwt = window.localStorage.getItem("jwt");
      let id = curso.idPersonaCurso;

      ObtenerEvaluacionesPersonaCurso({ jwt, id }).then((data) => {
        if (data && data.length > 0) {
          let dataTemp = data.filter((x) => x.intento == 1);
          if (dataTemp.length > 0) {
            let numUnidades = listaUnidades.length;
            let numEvaRealizadas = dataTemp.length;
            porcentajeEva = (numEvaRealizadas / numUnidades) * 100;
            setEvaluacionesProgreso(porcentajeEva);
          }
        }
        setEvaluaciones(data);
      });
    }
  }, [curso, listaUnidades]);

  const obtenerPorcentajeAvance = (totalLecciones) => {
    if (progresoCurso) {
      const porcentajes = progresoCurso.map((tiempo) => {
        let tiempoa = moment(tiempo.tiempoVideoActual).format("HH:mm:ss");
        let tiempot = moment(tiempo.tiempoVideoTotal).format("HH:mm:ss");
        return (timeToSeconds(tiempoa) / timeToSeconds(tiempot)) * 100;
      });

      const promedioPorcentajes =
        porcentajes.reduce((total, porcentaje) => total + porcentaje, 0) /
        totalLecciones;

      return (
        (isNaN(promedioPorcentajes) ? 0 : promedioPorcentajes) * 0.5 +
        evaluacionesProgreso * 0.5
      );
    } else {
      return 0; // evaluacionesProgreso * 0.5;
    }
  };
  /* 
  function obtenerPorcentajeAvance() {
    if (progresoCurso && listaLecciones && progresoCurso && listaUnidades) {
    
      const sumaPromedios = ProgresoUnidad.reduce((acumulador, elemento) => {
        const promedio = parseFloat(elemento.promedioPorcentaje);
        return acumulador + promedio;
      }, 0);
      var progresoPorcentaje = ((sumaPromedios / listaUnidades.length) / 2);
      const unidadesEvaluadas = new Set();
      /* evaluacionesProgreso.forEach((evaluacion) => {
        unidadesEvaluadas.add(evaluacion.idUnidad);
      }); 
      //const cantidadUnidadesEvaluadas = unidadesEvaluadas.size;
      var resultado = ((evaluacionesProgreso/ 2) + progresoPorcentaje);
      
      return 0 ; // resultado == NaN || resultado == Infinity ? 0 : resultado.toFixed(2);
    } else {
      return evaluacionesProgreso * 0.5;
    }
  };  */

  const Actualizar = () => {
    let idPersonaCurso = curso.idPersonaCurso;
    let idCurso = curso.idCurso;
    let finCurso = curso.finCurso;
    let idUsuario = curso.idUsuario;
    let idEstado = 2;
    let jsonCurso = JSON.stringify(
      { idPersonaCurso, idUsuario, idCurso, finCurso, idEstado },
      null,
      2
    );
    let jwt = window.localStorage.getItem("jwt");

    ActualizarCursoEstado({ jsonCurso, jwt }).then((data) => {
      //formik.setSubmitting(false)
      //toast.current.show({severity:'success', summary: 'Éxito', detail:"Registro actualizado exitosamente.", life: 7000})
      setTimeout(() => {
        setShowAlert(false);
        navigate(
          "/" + PrivateRoutes.HOME + "/CursoInterno/" + curso.idPersonaCurso
        );
        window.location.reload();
      }, 100);
    });
  };

  const solicitaAmpliacion = () => {
    setLoading(true);
    let jwt = window.localStorage.getItem("jwt");
    let id = curso.idPersonaCurso;
    SolicitarAmpliacion({ jwt, id })
      .then((data) => {
        setTimeout(() => {
          setLoading(false);
          setShowAmpliacion(false);
          window.location.reload();
        }, 3000);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  function DiasVigencia() {
    let fechaActual = new Date();
    let diferenciaEnDias = 0;

    let fechaVigenciaMmebresia = new Date(curso.fechaVigenciaMembresia);
    let fechaCalculable = curso.fechaAmpliacionCurso
      ? new Date(curso.fechaAmpliacionCurso)
      : new Date(curso.fechaVigencia);

      let fechaCalculableFinal = curso.fechaVigenciaMembresia
      ? fechaCalculable > fechaVigenciaMmebresia
        ? fechaVigenciaMmebresia
        : fechaCalculable
      : fechaCalculable;

    let diferenciaEnMilisegundos = fechaCalculableFinal - fechaActual;

    diferenciaEnDias = Math.floor(
      diferenciaEnMilisegundos / (1000 * 60 * 60 * 24)
    );
    if (
      diferenciaEnDias <= 4 &&
      diferenciaEnDias >= 0 &&
      AlertaEstaPorvencer == false
    ) {
      const expiracionAlerta = sessionStorage.getItem(
        "CursoExpiracionAlerta" + curso.idPersonaCurso
      );
      if (expiracionAlerta == null) {
        sessionStorage.setItem(
          "CursoExpiracionAlerta" + curso.idPersonaCurso,
          "AlertaActiva"
        );
        setShowEstaPorvencer(true);
      }
    }
    return <span>{diferenciaEnDias + 1}</span>;
  }

  /*   function ProgresoCursoPormedio() {
    let sum = 0;
    for (const item of ProgresoUnidad) {
      const percentage = parseFloat(item.promedioPorcentaje);
      sum += percentage;
    }
    const average = sum / ProgresoUnidad.length;
    //setProgresoCurso(average);
    return average.toFixed(2);
  } */

  const footerActivar = (
    <>
      <div style={{ marginBottom: 8 }}>
        <ButtonZegel
          label="Activar módulo"
          color="primary"
          onClick={() => Actualizar()}
        ></ButtonZegel>
      </div>
      <div>
        <ButtonZegel
          label="Cancelar"
          color="secondary"
          onClick={() => setShowAlert(false)}
        ></ButtonZegel>
      </div>
    </>
  );

  const footerAmpliacion = (
    <>
      <div style={{ marginBottom: 8 }}>
        <ButtonZegel
          label="Aceptar ampliación"
          color="primary"
          onClick={() => solicitaAmpliacion()}
          loading={loading}
        ></ButtonZegel>
      </div>
      <div>
        <ButtonZegel
          label="Cancelar"
          color="secondary"
          onClick={() => setShowAmpliacion(false)}
        ></ButtonZegel>
      </div>
    </>
  );

  const footerEstaPorVencer = (
    <>
      <div style={{ marginBottom: 8 }}>
        <ButtonZegel
          label="Continuar módulo"
          color="primary"
          onClick={() => {
            navigate(
              "/" + PrivateRoutes.HOME + "/CursoInterno/" + curso.idPersonaCurso
            );
          }}
          loading={loading}
        ></ButtonZegel>
      </div>
    </>
  );

  const contenidoAmpliacion = (
    <div>
      <span>
        <strong>{"Recuerda que..."}</strong>
      </span>
      <br></br>
      <br></br>
      <span style={{ fontSize: 12 }}>
        Tienes 14 días más para culminar con el módulo. Luego de esta ampliación
        el módulo quedará expirado permanentemente.{" "}
      </span>
    </div>
  );
  const contenidoActivar = (
    <div>
      <span>
        <strong>
          {"¿Estás seguro de que quieres activar el módulo " +
            curso.curso.nombre +
            "?"}
        </strong>
      </span>
      <br></br>
      <br></br>
      <span>
        Recuerda que tienes {
          curso.fechaVigenciaMembresia ? 
          (Math.ceil((new Date(curso.fechaVigenciaMembresia).getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24)))>30 ? 
            30: Math.ceil((new Date(curso.fechaVigenciaMembresia).getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24)) : 30
        } días para culminar el módulo, una vez comenzado
        no podrás desactivarlo.{" "}
      </span>
    </div>
  );

  const contenidoEstaPorVencer = (
    <div>
      <span>
        <strong>
          {"El módulo " + curso.curso.nombre + " está por vencer"}
        </strong>
      </span>
      <br></br>
      <br></br>
      <span style={{ fontSize: 12 }}>
        Recuerda que tienes <DiasVigencia /> días para culminar el módulo{" "}
      </span>
    </div>
  );

  const valueTemplate = (value) => {
    return (
      <React.Fragment>
        <span></span>
      </React.Fragment>
    );
  };

  function calcularPromedioNotasPorUnidad() {
    if (Evaluaciones) {
      const notasMaximasPorUnidad = {};
      const conteoEvaluacionesPorUnidad = {};
      Evaluaciones.forEach((evaluacion) => {
        const { idUnidad, nota } = evaluacion;
        if (
          !notasMaximasPorUnidad[idUnidad] ||
          nota > notasMaximasPorUnidad[idUnidad]
        ) {
          notasMaximasPorUnidad[idUnidad] = nota;
        }
        if (!conteoEvaluacionesPorUnidad[idUnidad]) {
          conteoEvaluacionesPorUnidad[idUnidad] = 1;
        } else {
          conteoEvaluacionesPorUnidad[idUnidad]++;
        }
      });
      let sumaNotas = 0;
      let totalUnidades = 0;
      for (const unidad in notasMaximasPorUnidad) {
        sumaNotas += notasMaximasPorUnidad[unidad];
        totalUnidades++;
      }
      const promedio = totalUnidades === 0 ? 0 : sumaNotas / totalUnidades;
      return promedio.toFixed(2);
    } else {
      return 0;
    }
  }

  const onDownloadCertificado = async() => {
        
    try{
      navigate("/" + PrivateRoutes.HOME + "/ShareCertificate/Program/" + idPrograma + "/" + personaPrograma  + "/" +  curso.curso.idCurso,{
        state: {downloading:true}
      });

        const res = await handleDownloadCertificado({
            cursoPersona: curso,
            // curso: curso.curso,
            persona: perfil,
            tipo:"Curso"
        });

        navigate("/" + PrivateRoutes.HOME + "/ShareCertificate/Program/" + idPrograma + "/" + personaPrograma  + "/" +  curso.curso.idCurso,{
            state: {downloading:false, res}
        });

    }catch(error){
        toast.error(error)
    }
  };

  function duracionEnHoras(duracion) {
    const partes = duracion.split(" ");
    if (partes.length === 2 && partes[1] === "h") {
      return parseFloat(partes[0]);
    }
    return 0;
  }
  
  return (
    <>
      <div className="card-curso">
        <div className="card-curso-header">
          {curso.curso.fotoCurso ? (
            <div className="card-curso-img">
              <img
                src={curso.curso.fotoCurso}
                className="c-user-course-card__banner"
              />
            </div>
          ) : (
            <div className="w-full" style={{ height: 190 }}></div>
          )}

          {curso.idEstado == 2 && (
            <ProgressBar
              className="progressBar-interna"
              value={Math.round(obtenerPorcentajeAvance(curso.numeroLecciones))}
              /* value={Math.round(obtenerPorcentajeAvance())} */
              displayValueTemplate={valueTemplate}
              style={{ marginTop: -4 }}
            ></ProgressBar>
          )}

          <h2 className="flex align-items-center mb-0 mt-2">
            {curso.curso.nombre}
          </h2>
        </div>
        <div className="card-curso-contenido">
          {cursoExpiradoMembresia ? (
            curso.idCondicion ? (
              curso.idCondicion == 2 ? (
                <>
                  <div style={{ fontSize: 12 }}>
                    Promedio desaprobado: {curso.promedio}
                  </div>
                  <div style={{ fontSize: 12 }}>
                    No puedes descargar el certificado.
                  </div>
                </>
              ) : (
                <p>Promedio aprobado: {curso.promedio}</p>
              )
            ) : (
              <p>
                <span className="pr-2">
                  El módulo ha expirado, tu membresia ha finalizado.
                </span>
              </p>
            )
          ) : curso.idEstado == 3 ? (
            <div className="aditional-info flex align-items-center gap-2">
              <p>{curso.curso.duracion}</p>
              <i className="pi pi-clock" style={{ fontSize: "10.45px" }}></i>
            </div>
          ) : curso.idEstado == 2 ? (
            <div className="aditional-info">
              {cursoExpirado && curso.fechaAmpliacionCurso == null ? (
                <p>
                  El módulo ha expirado, puedes solicitar una única ampliación
                  de 14 días.
                </p>
              ) : cursoExpiradoAmpliacion ? (
                <p>
                  <span className="pr-2">
                    El módulo ha expirado, solicitaste una ampliación el{" "}
                    {moment(curso.fechaAmpliacionCurso)
                      .subtract(14, "days")
                      .format("DD/MM/YY")}
                    .
                  </span>
                </p>
              ) : (
                <p>
                  <span className="pr-2">
                    Progreso{" "}
                    {`${Math.round(
                      obtenerPorcentajeAvance(curso.numeroLecciones)
                    )}%`}
                  </span>
                  <span>|</span>
                  <span className="pl-2">
                    Vence en <DiasVigencia /> días
                  </span>{" "}
                </p>
              )}
            </div>
          ) : (
            <div className="aditional-info w-full pb-2 pt-2">
              {curso.idCondicion == 2 ? (
                <>
                  <div style={{ fontSize: 12 }}>
                    Promedio desaprobado: {curso.promedio}
                  </div>
                  <div style={{ fontSize: 12 }}>
                    No puedes descargar el certificado.
                  </div>
                </>
              ) : (
                <p>Promedio aprobado: {curso.promedio}</p>
              )}
            </div>
          )}

          <div className="boton-accion">
            <div className="mb-2">
              {cursoExpiradoMembresia ? (
                curso.idCondicion ? (
                  <ButtonZegel
                    loading={loading}
                    label="Descargar certificado"
                    color="primary"
                    onClick={() => {
                      onDownloadCertificado();
                    }}
                    disabled={
                      curso.idEstado == 1 &&
                      curso.idCondicion != 2 &&
                      Evaluaciones &&
                      //calcularPromedioNotasPorUnidad() >=
                      curso.promedio >=
                        configuraciones?.filter(
                          (z) => z.codigo === "NOTA_MINIMA_APROB"
                        )[0].valor
                        ? false
                        : true
                    }
                  ></ButtonZegel>
                ) : (
                  <ButtonZegel
                    label="Módulo expirado"
                    color="primary"
                    disabled={true}
                  ></ButtonZegel>
                )
              ) : curso.idEstado == 3 ? (
                <ButtonZegel
                  label="Activar módulo"
                  color="primary"
                  onClick={() => {
                    setShowAlert(true);
                    setContenidoAlertActivar(contenidoActivar);
                  }}
                ></ButtonZegel>
              ) : curso.idEstado == 2 ? (
                cursoExpirado && curso.fechaAmpliacionCurso == null ? (
                  <ButtonZegel
                    label="Solicitar ampliación"
                    color="primary"
                    onClick={() => setShowAmpliacion(true)}
                  ></ButtonZegel>
                ) : cursoExpiradoAmpliacion ? (
                  <ButtonZegel
                    label="Curso expirado"
                    color="primary"
                    disabled={true}
                  ></ButtonZegel>
                ) : (
                  <ButtonZegel
                    label="Continuar módulo"
                    color="primary"
                    onClick={() => {
                      navigate(
                        "/" +
                          PrivateRoutes.HOME +
                          "/CursoInterno/" +
                          curso.idPersonaCurso
                      );
                    }}
                  ></ButtonZegel>
                )
              ) : (
                <ButtonZegel
                  loading={loading}
                  label="Descargar certificado"
                  color="primary"
                  onClick={() => {
                    onDownloadCertificado();
                  }}
                  disabled={
                    curso.idEstado == 1 &&
                    curso.idCondicion != 2 &&
                    Evaluaciones &&
                    //calcularPromedioNotasPorUnidad() >=
                    curso.promedio >=
                      configuraciones?.filter(
                        (z) => z.codigo === "NOTA_MINIMA_APROB"
                      )[0].valor
                      ? false
                      : true
                  }
                ></ButtonZegel>
              )}
            </div>
            <div>
              <ButtonZegel
                label="Mi progreso"
                color="secondary"
                onClick={() => {
                  personaPrograma == null
                    ? navigate(
                        "/" +
                          PrivateRoutes.HOME +
                          "/ProgresoCurso/" +
                          curso.idCurso
                      )
                    : navigate(
                        "/" +
                          PrivateRoutes.HOME +
                          "/ProgresoPrograma/" +
                          idPrograma +
                          "/" +
                          personaPrograma +
                          "/" +
                          curso.idCurso
                      );
                }}
              ></ButtonZegel>
            </div>
          </div>
        </div>
      </div>
      <div className="card-curso-mobile">
        <div className="curso-mobile-header flex align-items- gap-3">
          <div className="mobile-header-img">
            {curso.curso.fotoCurso ? (
              <img
                src={curso.curso.fotoCurso}
                className="c-user-course-card__banner"
              />
            ) : (
              <div style={{ height: 100, width: 100 }}></div>
            )}
          </div>
          <div className="mobile-header-contenido">
            <div className="header-contenido-titulo">
              <label className="mb-0">{curso.curso.nombre}</label>
            </div>
            <div
              className="header-contenido-adicional"
              style={{ marginTop: "10px" }}
            >
              {cursoExpiradoMembresia ? (
                curso.idCondicion ? (
                  curso.idCondicion == 2 ? (
                    <>
                      <div style={{ fontSize: 12 }}>
                        Promedio desaprobado: {curso.promedio}
                      </div>
                      <div style={{ fontSize: 12 }}>
                        No puedes descargar el certificado.
                      </div>
                    </>
                  ) : (
                    <p>Promedio aprobado: {curso.promedio}</p>
                  )
                ) : (
                  <p>
                    <span className="pr-2">
                      El módulo ha expirado, tu membresia ha finalizado.
                    </span>
                  </p>
                )
              ) : curso.idEstado == 3 ? (
                <div className="aditional-info flex align-items-center gap-2">
                  <p style={{ fontSize: 12 }}>{curso.curso.duracion}</p>
                  <i
                    className="pi pi-clock"
                    style={{ fontSize: "10.45px" }}
                  ></i>
                </div>
              ) : curso.idEstado == 2 ? (
                <div className="aditional-info">
                  <p style={{ fontSize: 12 }}>
                    <span className="pr-2">
                      Progreso{" "}
                      {`${Math.round(
                        obtenerPorcentajeAvance(curso.numeroLecciones)
                      )}%`}
                    </span>
                    <span>|</span>
                    <span className="pl-2">Vence en 30 días</span>{" "}
                  </p>
                  <ProgressBar
                    className="progressBar-interna"
                    value={Math.round(
                      obtenerPorcentajeAvance(curso.numeroLecciones)
                    )}
                    displayValueTemplate={valueTemplate}
                  ></ProgressBar>
                </div>
              ) : (
                <div className="aditional-info">
                  {curso.idCondicion == 2 ? (
                    <>
                      <div style={{ fontSize: 12 }}>
                        Promedio desaprobado: {curso.promedio}
                      </div>
                      <div style={{ fontSize: 12 }}>
                        No puedes descargar el certificado.
                      </div>
                    </>
                  ) : (
                    <p>Promedio aprobado: {curso.promedio}</p>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
        <div
          className={classNames("boton-accion mt-2 w-full", {
            block: curso.idEstado == 1 ? true : false,
          })}
        >
          <div
            className={classNames({
              "mb-2": curso.idEstado == 1 ? true : false,
            })}
            style={{ width: "100%" }}
          >
            {cursoExpiradoMembresia ? (
              curso.idCondicion ? (
                <ButtonZegel
                  loading={loading}
                  label="Descargar certificado"
                  color="primary"
                  onClick={() => {
                    onDownloadCertificado();
                  }}
                  disabled={
                    curso.idEstado == 1 &&
                    curso.idCondicion != 2 &&
                    Evaluaciones &&
                    //calcularPromedioNotasPorUnidad() >=
                    curso.promedio >=
                      configuraciones?.filter(
                        (z) => z.codigo === "NOTA_MINIMA_APROB"
                      )[0].valor
                      ? false
                      : true
                  }
                ></ButtonZegel>
              ) : (
                <ButtonZegel
                  label="Módulo expirado"
                  color="primary"
                  disabled={true}
                ></ButtonZegel>
              )
            ) : curso.idEstado == 3 ? (
              <ButtonZegel
                label="Activar módulo"
                color="primary"
                onClick={() => {
                  setShowAlert(true);
                  setContenidoAlertActivar(contenidoActivar);
                }}
              ></ButtonZegel>
            ) : curso.idEstado == 2 ? (
              <ButtonZegel
                label="Continuar módulo"
                color="primary"
                onClick={() => {
                  navigate(
                    "/" +
                      PrivateRoutes.HOME +
                      "/CursoInterno/" +
                      curso.idPersonaCurso
                  );
                }}
              ></ButtonZegel>
            ) : (
              <ButtonZegel
                loading={loading}
                label="Descargar certificado"
                color="primary"
                onClick={() => {
                  onDownloadCertificado();
                }}
                disabled={
                  curso.idEstado == 1 &&
                  curso.idCondicion != 2 &&
                  Evaluaciones &&
                  //calcularPromedioNotasPorUnidad() >=
                  curso.promedio >=
                    configuraciones?.filter(
                      (z) => z.codigo === "NOTA_MINIMA_APROB"
                    )[0].valor
                    ? false
                    : true
                }
              ></ButtonZegel>
            )}
          </div>
          <div>
            {/*             <ButtonZegel
              label="Mi progreso"
              color="secondary"
              onClick={() =>
                navigate(
                  "/" + PrivateRoutes.HOME + "/ProgresoCurso/" + curso.idCurso
                )
              }
            ></ButtonZegel> */}
            <ButtonZegel
              label="Mi progreso"
              color="secondary"
              onClick={() => {
                personaPrograma == null
                  ? navigate(
                      "/" +
                        PrivateRoutes.HOME +
                        "/ProgresoCurso/" +
                        curso.idCurso
                    )
                  : navigate(
                      "/" +
                        PrivateRoutes.HOME +
                        "/ProgresoPrograma/" +
                        idPrograma +
                        "/" +
                        personaPrograma +
                        "/" +
                        curso.idCurso
                    );
              }}
            ></ButtonZegel>
          </div>
        </div>
      </div>
      <DialogZegel
        header=""
        visible={showAlert}
        width="30vw"
        onHide={() => setShowAlert(false)}
        footer={footerActivar}
        contenido={contenidoAlertActivar}
      ></DialogZegel>
      <DialogZegel
        header=""
        visible={showAmpliacion}
        width="30vw"
        onHide={() => setShowAmpliacion(false)}
        footer={footerAmpliacion}
        contenido={contenidoAmpliacion}
      ></DialogZegel>
      <DialogZegel
        header=""
        visible={ShowEstaPorvencer}
        width="30vw"
        onHide={() => {
          setShowEstaPorvencer(false);
          setAlertaEstaPorvencer(true);
        }}
        footer={footerEstaPorVencer}
        contenido={contenidoEstaPorVencer}
      ></DialogZegel>
    </>
  );
}

export default CardPrograma;
